import React from "react";
import AnsibleItem from "./AnsibleItem";

const AnsibleList = ({ jobs, onItemClick }) => {
  if (jobs.length === 0) return <p>등록된 작업이 없습니다.</p>;

  return (
    <div className="space-y-2">
      {jobs.map((job) => (
        <AnsibleItem key={job.id} job={job} onClick={onItemClick} />
      ))}
    </div>
  );
};

export default AnsibleList;
